
import { useState, useEffect } from 'react';
import SigilPlaceholder from './SigilPlaceholder';

const rotatingWords = ['Unity', 'Harmony', 'Clarity', 'Connection', 'Integration'];

export default function Hero() {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentWordIndex((prev) => (prev + 1) % rotatingWords.length);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center relative px-6">
      {/* Sigil */}
      <div className="mb-12">
        <SigilPlaceholder />
      </div>

      {/* Rotating Words with Futuristic Thin Font */}
      <div className="mb-8 h-16 flex items-center">
        <h2 className="text-4xl md:text-5xl font-orbitron tracking-[0.5em] font-light text-transparent bg-gradient-to-r from-violet-400 via-cyan-300 to-violet-400 bg-clip-text animate-pulse">
          {rotatingWords[currentWordIndex]}
        </h2>
      </div>

      {/* Tagline */}
      <div className="text-center max-w-4xl">
        <p className="text-lg md:text-xl font-light tracking-wide text-gray-400 leading-relaxed mb-4">
          The Gathered Voice of Minds
        </p>
        
        {/* Main Title */}
        <div className="mb-6">
          <h1 className="text-2xl md:text-3xl lg:text-4xl tracking-wider text-transparent bg-gradient-to-r from-violet-300 via-cyan-200 to-violet-300 bg-clip-text font-orbitron">
            Coalescence: The Collective's Words
          </h1>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2">
        <div className="w-6 h-10 border-2 border-violet-400/50 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-violet-400 rounded-full mt-2 animate-bounce"></div>
        </div>
      </div>
    </div>
  );
}
